import * as clipboard from "expo-clipboard";
import useToast from "@/hooks/useToast";
import { ActionButton, actionButtonStyles } from "./ActionButton";

interface CopyUrlButtonProps {
  entityType?: string;
  entityId?: string;
}

export function CopyUrlButton({ entityType, entityId }: CopyUrlButtonProps) {
  const toast = useToast();

  const handleCopyUrl = async () => {
    try {
      await clipboard.setStringAsync(`http://${window.location.host}/${entityType}s/${entityType}/${entityId}`);
      toast.showToast({
        title: "Copied!",
        message: "URL copied to clipboard",
        toastType: "info",
      });
    } catch {
      toast.showToast({
        title: "Error",
        message: "Failed to copy URL",
        toastType: "error",
      });
    }
  };

  return (
    <ActionButton
      icon="content-copy"
      onPress={handleCopyUrl}
      tooltip="Copy URL"
      style={actionButtonStyles.iconBtn}
      tooltipOffsetX={-20}
    />
  );
}
